(function () {
  'use strict';

  function initCopyrightAnimation() {
    const copyrightElement = document.querySelector('.nr-footer .copyright-left');
    if (!copyrightElement) return;

    const defaultText = copyrightElement.getAttribute('data-default') || '';
    const hoverText = copyrightElement.getAttribute('data-hover') || '';
    let isAnimating = false;
    let currentText = defaultText;

    copyrightElement.textContent = defaultText;

    function animateText(targetText) {
      if (isAnimating || !targetText) return;
      isAnimating = true;

      const maxLength = Math.max(currentText.length, targetText.length);
      let currentIndex = 0;

      const interval = setInterval(function () {
        if (currentIndex <= maxLength) {
          let newText = '';
          for (let i = 0; i < maxLength; i++) {
            if (i < currentIndex) {
              newText += targetText[i] || '';
            } else {
              newText += currentText[i] || '';
            }
          }
          copyrightElement.textContent = newText.trim();
          currentIndex++;
        } else {
          clearInterval(interval);
          currentText = targetText;
          copyrightElement.textContent = targetText;
          isAnimating = false;
        }
      }, 30);
    }

    copyrightElement.addEventListener('mouseenter', function () {
      animateText(hoverText);
    });

    copyrightElement.addEventListener('mouseleave', function () {
      animateText(defaultText);
    });
  }

  function initLuckyLink() {
    if (window.NRLucky) {
      window.NRLucky.bind('.nr-footer .lucky-link');
      return;
    }
    const luckyLink = document.querySelector('.nr-footer .lucky-link');
    if (!luckyLink) return;
    luckyLink.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/blogs/archive';
    });
  }

  function init() {
    initCopyrightAnimation();
    initLuckyLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
